const getApiBaseUrl = (protocol) => {
  return (
    protocol +
    (process.env.REACT_APP_IS_SECURE === "true" ? "s" : "") +
    "://" +
    process.env.REACT_APP_API_URL
  );
};

export default getApiBaseUrl;
